export default {
  computed: {
    isBannedFromEditing: function() {
      return (this.$store.state.company.COMPANY) ? this.$store.state.company.COMPANY.ban_edit : false;
    },
  }
}
